import { gradientFor, initialsFor } from "./avatarLook";
import styles from "./Avatar.module.css";

interface AvatarProps {
  name?: string;
  image?: string;
  size?: number;
  /**
   * When false (or `variant="neutral"`), the fallback uses a neutral accent
   * tint instead of a per-user gradient — useful for "default" empty avatars
   * in popups and placeholders.
   */
  gradient?: boolean;
  variant?: "gradient" | "neutral";
}

export function Avatar({
  name,
  image,
  size = 32,
  gradient,
  variant,
}: AvatarProps) {
  if (image) {
    return (
      <img
        src={image}
        width={size}
        height={size}
        className={styles.avatar}
        alt=""
      />
    );
  }
  const useNeutral = gradient === false || variant === "neutral";
  const initials = initialsFor(name);
  // Initials font-size scales to ~42% of avatar size — keeps readable across
  // the 24/28/32/36/48 presets.
  const fontSize = Math.max(10, Math.round(size * 0.42));
  const style: React.CSSProperties = {
    width: size,
    height: size,
    fontSize,
  };
  if (useNeutral) {
    return (
      <div
        className={`${styles.fallback} ${styles.neutral}`}
        style={style}
        aria-hidden
      >
        {initials}
      </div>
    );
  }
  return (
    <div
      className={`${styles.fallback} ${styles.gradient}`}
      style={{ ...style, background: gradientFor(name ?? "") }}
      aria-hidden
    >
      {initials}
    </div>
  );
}
